// Información de build generada automáticamente
export const BUILD_DATE = '07-07-2026 19:46:49';
export const BUILD_HASH = '03i6s4q98uj';
export const APP_VERSION = '0.0.0';
export const BUILD_TIMESTAMP = 1783464409249;

// Para debugging en consola
console.log('%cℹ️ Build Info', 'color: #2196F3; font-weight: bold;', {
  buildDate: '07-07-2026 19:46:49',
  buildHash: '03i6s4q98uj',
  appVersion: '0.0.0',
  timestamp: 1783464409249
});
